module.exports = __webpack_public_path__ + "img/1508772138.e4e47015.jpg";